import React, { useEffect } from 'react';
interface SplashScreenProps {
  onNext: () => void;
}
export function SplashScreen({
  onNext
}: SplashScreenProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onNext();
    }, 2000);
    return () => clearTimeout(timer);
  }, [onNext]);
  return <div className="flex flex-col items-center justify-center h-full w-full text-white px-6" style={{
    background: 'linear-gradient(to bottom, #134073, #3d99d2)'
  }} data-id="element-239">
      <div className="bg-white p-6 rounded-2xl shadow-xl mb-8 w-full max-w-[240px] flex items-center justify-center" data-id="element-240">
        <img src="https://cdn.magicpatterns.com/uploads/wszHE4itFVKfiMMSe74Psk/logohospigen.png" alt="Logo Hospital San Juan de Dios" className="w-full h-auto object-contain" data-id="element-241" />
      </div>

      <h1 className="text-3xl font-bold text-center mb-2 tracking-tight" data-id="element-242">
        Lavandería
        <br data-id="element-243" />
        Hospitalaria
      </h1>
      <p className="text-white/80 text-lg text-center mb-16 font-medium" data-id="element-244">
        Hospital San Juan de Dios
      </p>

      <div className="absolute bottom-16 flex space-x-2" data-id="element-245">
        <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{
        animationDelay: '0s'
      }} data-id="element-246"></div>
        <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{
        animationDelay: '0.2s'
      }} data-id="element-247"></div>
        <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{
        animationDelay: '0.4s'
      }} data-id="element-248"></div>
      </div>
    </div>;
}